function MedicinesIcon() {
  return (
    <span className="anticon ant-menu-item-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="#A9A9A9"
          strokeWidth="1.5"
          d="M8.5 8H8c-1.886 0-2.828 0-3.414.586S4 10.114 4 12v3.5c0 1.886 0 2.828.586 3.414S6.114 19.5 8 19.5h8c1.886 0 2.828 0 3.414-.586S20 17.386 20 15.5V12c0-1.886 0-2.828-.586-3.414S17.886 8 16 8h-.5m-7 0v-.5c0-1.414 0-2.121.44-2.56.439-.44 1.146-.44 2.56-.44h1c1.414 0 2.121 0 2.56.44.44.439.44 1.146.44 2.56V8m-7 0h7"
        ></path>
        <path
          fill="#A9A9A9"
          d="M10.932 10.963c-.057.138-.057.313-.057.662v.714q.001.024-.005.03-.007.007-.031.006h-.714c-.35 0-.524 0-.662.057a.75.75 0 0 0-.406.406C9 12.976 9 13.151 9 13.5s0 .524.057.662a.75.75 0 0 0 .406.406c.138.057.313.057.662.057h.714q.024-.001.03.005.007.007.006.031v.714c0 .35 0 .524.057.662a.75.75 0 0 0 .406.406c.138.057.313.057.662.057s.524 0 .662-.057a.75.75 0 0 0 .406-.406c.057-.138.057-.312.057-.662v-.714q-.001-.024.005-.03.007-.007.031-.006h.714c.35 0 .524 0 .662-.057a.75.75 0 0 0 .406-.406C15 14.024 15 13.85 15 13.5s0-.524-.057-.662a.75.75 0 0 0-.406-.406c-.138-.057-.312-.057-.662-.057h-.714q-.024.001-.03-.005-.007-.007-.006-.031v-.714c0-.35 0-.524-.057-.662a.75.75 0 0 0-.406-.406c-.138-.057-.312-.057-.662-.057s-.524 0-.662.057a.75.75 0 0 0-.406.406"
        ></path>
      </svg>
    </span>
  );
}

export default MedicinesIcon;
